import { Language } from './languages.model';

export function generateLanguagesObject(): Language {
  return {
    id: 'en',
    code: 'en',
    name: 'English',
    englishName: 'English',
    active: true,
  };
}
